<template>
  <page-header-wrapper>
    <div class="back-content">
      <a-button
        class="tabButton"
        type="link"
        @click="goToTab"
      >
        返回上一页
      </a-button>
      <div class="search-form">
        <div class="search-form-left">
          <div class="form">
            <a-form-model
              :model="form"
              layout="inline"
            >
              <a-form-model-item
                label="基地："
                prop="baseId"
              >
                <a-select
                  v-model="form.baseId"
                  placeholder="请选择基地"
                  show-search
                  :filter-option="filterOption"
                  @change="baseChange"
                  @inputKeydown="inputKeydown($event, fetchData)"
                >
                  <a-select-option
                    v-for="item in baseOptions"
                    :key="item.baseId"
                  >
                    {{ item.baseName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-form-model>
          </div>
          <div class="ant-btns-mrright">
            <TableActions
              :actions="headerActions"
              @checkResource="fetchData"
              @checkAllDetail="checkAllDetail"
            />
          </div>
        </div>
        <div class="search-form-right">
          <TableActions
            :actions="addActions"
            @exportResource="exportBaseDetails"
          />
        </div>
      </div>
      <div class="table">
        <a-table
          :columns="columns"
          :data-source="dataSource"
          :loading="loading"
          :pagination="false"
          style="padding: 16px 0; background-color: #fff;"
          :row-key="(item, index) => index"
          :scroll="{ x: 1200 }"
        >
          <template
            slot="operatorYear"
            slot-scope="text,record"
          >
            {{ record.operatorYear }}
          </template>

          <template
            slot="resourceName"
            slot-scope="text,record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottom"
            >
              {{ item.resourceName }}
            </a-row>

            <a-row
              class="sum"
              style="visibility: hidden;"
            >
              ''
            </a-row>
          </template>

          <template
            slot="productTypeNameList"
            slot-scope="text,record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottom"
            >
              <div>
                <a-tooltip
                  placement="topLeft"
                  :title="`${item.productTypeNameList.join(',')}`"
                >
                  {{ item.productTypeNameList.join(',') }}
                </a-tooltip>
              </div>
            </a-row>

            <a-row
              class="sum"
            >
              合计
            </a-row>
          </template>

          <template
            slot="allocationAmount"
            slot-scope="text,record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottom"
            >
              <!-- {{ item.allocationAmount }} -->
              <div>
                <a-tooltip
                  placement="topLeft"
                  :title="`${item.allocationAmount}`"
                >
                  {{ item.allocationAmount }}
                </a-tooltip>
              </div>
            </a-row>

            <a-row
              class="sum"
            >
              {{ record.totalAllocationAmount }}
            </a-row>
          </template>

          <template
            slot="ratio"
            slot-scope="text,record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottom"
            >
              {{ item.ratio + '%' }}
            </a-row>
            <a-row
              class="sum"
              style="visibility: hidden;"
            >
              {{}}
            </a-row>
          </template>

          <template
            slot="quantity"
            slot-scope="text,record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottom"
            >
              {{ item.quantity }}
            </a-row>
            <a-row
              class="sum"
              style="visibility: hidden;"
            >
              {{}}
            </a-row>
          </template>

          <template
            slot="unit"
            slot-scope="text,record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottom"
            >
              {{ item.unit }}
            </a-row>
            <a-row
              class="sum"
              style="visibility: hidden;"
            >
              {{}}
            </a-row>
          </template>

          <template
            slot="contractAmount"
            slot-scope="text,record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottom"
            >
              <div>
                <a-tooltip
                  placement="topLeft"
                  :title="`${item.contractAmount}`"
                >
                  {{ item.contractAmount }}
                </a-tooltip>
              </div>
            </a-row>

            <a-row
              class="sum"
            >
              {{ record.totalContractAmount }}
            </a-row>
          </template>

          <template
            slot="availableAmount"
            slot-scope="text,record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottom"
            >
              <div>
                <a-tooltip
                  placement="topLeft"
                  :title="`${item.availableAmount}`"
                >
                  {{ item.availableAmount }}
                </a-tooltip>
              </div>
            </a-row>

            <a-row
              class="sum"
            >
              {{ record.totalAvailableAmount }}
            </a-row>
          </template>

          <template
            slot="saleAmount"
            slot-scope="text,record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottom"
            >
              {{ item.saleAmount }}
            </a-row>
            <a-row
              class="sum"
            >
              {{ record.totalSaleAmount }}
            </a-row>
          </template>

          <template
            slot="distributionAmount"
            slot-scope="text,record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottom"
            >
              <div>
                <a-tooltip
                  placement="topLeft"
                  :title="`${item.distributionAmount}`"
                >
                  {{ item.distributionAmount }}
                </a-tooltip>
              </div>
            </a-row>

            <a-row
              class="sum"
            >
              {{ record.totalDistributionAmount }}
            </a-row>
          </template>

          <template
            slot="remainAmount"
            slot-scope="text,record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottom"
            >
              <div>
                <a-tooltip
                  placement="topLeft"
                  :title="`${item.remainAmount}`"
                  :class="item.fragment? 'fragment': ''"
                >
                  {{ item.remainAmount }}
                </a-tooltip>
              </div>
            </a-row>

            <a-row
              class="sum"
            >
              {{ record.totalRemainAmount }}
            </a-row>
          </template>

          <span
            v-if="!record.showAction"
            slot="actions"
            slot-scope="text, record"
          >
            <a-row
              v-for="(item,index) in record.resources"
              :key="index"
              class="bottomAction"
            >
              <TableActions
                :actions="!record.flag ? tableActions : []"
                :record="record"
                @detailChange="detailChange(item, record)"
                @checkDetail="checkDetail(item, record)"
              />
            </a-row>

            <a-row>
              <TableActions
                :actions=" []"
                :record="record"
                class="action"
              />
            </a-row>
          </span>
        </a-table>
      </div>
      <BaseDetailsModal
        :init-data="initData"
        :visible="modalVisible"
        :loading="confirmLoading"
        :base-options="baseOptions"
        :resource-id="resourceId"
        :base-id="baseId"
        :modal-title="modalTitle"
        @cancel="handleCancel"
        @ok="handleOk"
      />
      <operatorYearModal
        :visible="operatorYearModalVisible"
        :loading="confirmLoading"
        :base-options="baseOptions"
        :resource-id="resourceId"
        :modal-title="modalTitle"
        @cancel="handleCancel"
      />
      <checkAllDetailModal
        :visible="checkAllDetailModalVisible"
        :base-id="baseId"
        :loading="confirmLoading"
        :base-options="baseOptions"
        @cancel="handleCancel"
      />

      <ExportTables
        :visible="exportVisible"
        :loading="confirmLoading"
        :import-options="importOptions"
        :is-month="isMonth"
        @cancel="handleCancel"
        @exportOk="exportOk"
      />
    </div>
  </page-header-wrapper>
</template>

<script>
import BaseDetailsModal from './BaseDetailsModal.vue'
import { queryBaseDetails, exportBaseDetails, checkLock } from '@/api/baseDetail.js'
import OperatorYearModal from './OperatorYearModal.vue'
import {
  queryBases
} from '@/api/common.js'
import checkAllDetailModal from './CheckAllDetailModal.vue'
import { sleep, excelDown, filterOption, inputKeydown } from '@/utils/utils'
import ExportTables from '@/components/exportTables/exportTables.vue'

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'checkResource'
  },
  {
    title: '查看全部归属详情',
    type: 'primary',
    action: 'checkAllDetail'
  }
]

const addActions = [{
  title: '导出',
  type: 'primary',
  action: 'exportResource',
  apis: ['@baseInfo/Export_Bases'],
  ghost: true
}]

const columns = [
  {
    title: '运营年度',
    dataIndex: 'operatorYear',
    key: 'operatorYear',
    width: '110px',
    customRender: (text, row) => {
      return {
        children: `${text}`,
        attrs: {
          rowSpan: row.baseRowSpan
        }
      }
    },
    scopedSlots: { customRender: 'operatorYear' }
  },
  {
    title: '资源包类型',
    width: '130px',
    dataIndex: 'resourceName',
    key: 'resourceName',
    scopedSlots: { customRender: 'resourceName' }
  },
  {
    title: '资源内容',
    dataIndex: 'productTypeNameList',
    key: 'productTypeNameList',
    width: '150px',
    scopedSlots: { customRender: 'productTypeNameList' }
  },
  {
    title: '资源包配比',
    dataIndex: 'ratio',
    key: 'ratio',
    width: '120px',
    scopedSlots: { customRender: 'ratio' }
  },
  {
    title: '数量',
    dataIndex: 'quantity',
    key: 'quantity',
    width: '100px',
    scopedSlots: { customRender: 'quantity' }
  },
  {
    title: '单位',
    dataIndex: 'unit',
    key: 'unit',
    width: '100px',
    scopedSlots: { customRender: 'unit' }
  },
  {
    title: '应回款额',
    dataIndex: 'contractAmount',
    key: 'contractAmount',
    width: '120px',
    scopedSlots: { customRender: 'contractAmount' }
  },
  {
    title: '销售额',
    dataIndex: 'saleAmount',
    key: 'saleAmount',
    width: '120px',
    scopedSlots: { customRender: 'saleAmount' }
  },
  {
    title: '已回款额',
    dataIndex: 'allocationAmount',
    key: 'allocationAmount',
    width: '120px',
    scopedSlots: { customRender: 'allocationAmount' }
  },
  {
    title: '可发额度',
    dataIndex: 'availableAmount',
    key: 'availableAmount',
    width: '120px',
    scopedSlots: { customRender: 'availableAmount' }
  },
  {
    title: '已发额度',
    dataIndex: 'distributionAmount',
    key: 'distributionAmount',
    width: '120px',
    scopedSlots: { customRender: 'distributionAmount' }
  },
  {
    title: '剩余额度',
    dataIndex: 'remainAmount',
    key: 'remainAmount',
    width: '120px',
    scopedSlots: { customRender: 'remainAmount' }
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: '200px',
    scopedSlots: { customRender: 'actions' }
  }
]
const tableActions = [
  {
    title: '详情变更',
    type: 'link',
    action: 'detailChange',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '查看详情',
    type: 'link',
    action: 'checkDetail'
  }
]
export default {
  components: {
    BaseDetailsModal,
    OperatorYearModal,
    checkAllDetailModal,
    ExportTables
  },
  data () {
    return {
      headerActions,
      columns,
      dataSource: [],
      dataSourceTempt: [],
      arr: [],
      loading: false,
      baseOptions: [],
      resourceName: '',
      resourceId: '',
      tableActions,
      modalVisible: false,
      operatorYearModalVisible: false,
      checkAllDetailModalVisible: false,
      confirmLoading: false,
      initData: null,
      form: {
        baseId: ''
      },
      baseId: '',
      modalTitle: '',
      addActions,
      exportVisible: false,
      importOptions: undefined,
      isMonth: false,
      id: this.$route.query.id,
      isCheck: this.$route.query.isCheck
    }
  },
  created () {
    this.loading = true
    this.fetchSearchOptions()
    this.fetchData()
  },
  methods: {
    excelDown,
    filterOption,
    inputKeydown,
    async fetchSearchOptions () {
      await queryBases().then((data) => {
        this.baseOptions = data
        this.form.baseId = this.id
        this.baseId = this.form.baseId
      })
    },
    baseChange (value) {
      this.baseId = value
    },
    async fetchData () {
      this.loading = true
      await sleep(300)
      queryBaseDetails({
        baseId: this.form.baseId
      }).then((data) => {
        this.dataSource = data || []
      })
      this.loading = false
    },
    exportBaseDetails () {
      this.exportVisible = true
      this.importOptions = [{ label: '导出全部基地', value: '1' }, { label: '导出单个基地', value: '2' }]
    },
    exportOk (value) {
      exportBaseDetails({
        baseId: this.form.baseId,
        subRecord: value
      }).then((data) => {
        this.excelDown(data, '详情配置')
        this.handleCancel()
      })
    },
    detailChange (record, params) {
      checkLock({
        resourceId: record.resourceId
      }).then((data) => {
        this.modalVisible = true
      }).catch((error) => {
        if (error) {
          this.modalVisible = false
        }
      })
      this.resourceId = record.resourceId
      this.baseId = this.form.baseId
      this.baseOptions.forEach((item) => {
        if (item.baseId === this.form.baseId) {
          this.form.baseName = item.baseName
        }
      })
      this.modalTitle = this.form.baseName + ' ' + params.operatorYear
    },
    checkDetail (record, params) {
      this.resourceId = record.resourceId
      this.operatorYearModalVisible = true
      this.baseOptions.forEach((item) => {
        if (item.baseId === this.form.baseId) {
          this.form.baseName = item.baseName
        }
      })
      this.modalTitle = this.form.baseName + ' ' + params.operatorYear + ' ' + record.resourceName
    },
    checkAllDetail () {
      this.checkAllDetailModalVisible = true
    },
    handleCancel () {
      this.modalVisible = false
      this.exportVisible = false
      this.operatorYearModalVisible = false
      this.checkAllDetailModalVisible = false
    },
    handleOk () {
      this.handleCancel()
      this.fetchData()
    },
    goToTab () {
      this.$router.push(`/admin/resource/setting?id=${this.id}&isCheck=${this.isCheck}`)
    }
  }
}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}
.bottom {
  border-bottom: 1px solid #e8e8e8;
  padding: 20px;
  height: 62px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

}

.sum {
  padding: 20px;
  height: 62px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.bottomAction {
  border-bottom: 1px solid #e8e8e8;
  padding: 20px;
  height: 62px;
}

.action {
  // border-bottom: 1px solid #e8e8e8;
  padding: 20px;
  visibility: hidden;
  display: block;
  height: 62px;
}

/deep/ .table .ant-table-tbody > tr > td:not(:first-child) {
  padding: 0;
}

.fragment {
  color: red;
}

// .tabButton {
//   display: flex;
//   justify-content: flex-end;
// }
</style>
